import React from "react";
import OpcionDefecto from "../../../../../Common/Components/OpcionDefecto";
import CheckDefecto from "../../../../../Common/Components/CheckDefecto";
import ExpHelper from '../../../../../Common/Helpers/ExpHelper';

const HabilitacionTarjetaCajeroAutomatico = ({ data, selectCheckBox, selectCombo }) => {
    const { GET_PARAMETRO_GENERAL, GET_ATLAS_HABILITACION_TARJETA } = data;
    const arrayAux = GET_ATLAS_HABILITACION_TARJETA.filter(d => d.Checked);
    const acentoLetraOminuscula = ExpHelper.ConvertirCaracter("o");
    const acentoLetraAminuscula = ExpHelper.ConvertirCaracter("a");
    const acentoLetraEminuscula = ExpHelper.ConvertirCaracter("e");

    if (!GET_PARAMETRO_GENERAL) {
        return null;
    }

    if (!GET_PARAMETRO_GENERAL.SINOREDBANELCO) {
        return null
    }
    return (
        <div className="row top-separator-xs">
            <div className="col-xs-12">
                <label className="label-primary">{"Habilitaci" + acentoLetraOminuscula + "n de Tarjetas en Cajeros Autom" + acentoLetraAminuscula + "ticos"}</label>
                <div className="container-radio radio-margin"><label className="label-secondary">Tipo de Transacciones:</label></div>
                <div className="container-radio radio-margin"><label className="label-secondary">ADE: Adelantos de Efectivo</label></div>
                <div className="container-radio radio-margin"><label className="label-secondary">CON: Consulta de Saldo</label></div>
                <div className="container-radio radio-margin"><label className="label-secondary">PIN: Cambio de Clave Persona</label></div>
                <div className="container-radio radio-margin"><label className="label-secondary">PCH: Pago de Cheque / en Efectivo</label></div>
                <div className="container-radio radio-margin"><label className="label-secondary">{"PDC: Pago con D" + acentoLetraEminuscula + "bito en Cuenta"}</label></div>
          
                {GET_ATLAS_HABILITACION_TARJETA.map((item) => {
                    const referencia = `GFTA-${item.Id}`;
                    let inactivo = item.Descripcion.toLowerCase().match(/ inactivo/);
                    return (
                        (item.Activo && !inactivo) ? <CheckDefecto
                            key={item.Id}
                            nombre={item.Descripcion}
                            check={item.Checked}
                            activo={item.Activo}
                            referencia={referencia}
                            selectCheckBox={() => selectCheckBox("GET_ATLAS_HABILITACION_TARJETA", item.Id)} /> : null
                    )
                })}
                </div> 
                <div className="col-xs-12">
                    <OpcionDefecto
                        selecciono={arrayAux.length}
                    infoData={arrayAux}
                    referencia={"HabilitacionCajerosDefaultId"}
                    valorCombo={data.HabilitacionCajerosDefaultId}
                    valorChecked={data.HabilitacionCajerosDefaultInterfaz}
                    selectCombo={(value) => selectCombo("HabilitacionCajerosDefaultId", value)}
                    selectCheckBox={(value) => selectCheckBox("HabilitacionCajerosDefaultInterfaz", value)}
                    /> 

                    {(data.ERROR_PRODUCT["seleccionoTarjetaCajeroAutomatico"] == false && arrayAux.length === 0)
                        && <label className="error">{"Debe seleccionar al menos una habilitaci" + acentoLetraOminuscula + "n de tarjeta en cajeros autom" + acentoLetraAminuscula + "ticos."}</label>}
            </div>
        </div>
    );
}

export default HabilitacionTarjetaCajeroAutomatico;